// extracted by mini-css-extract-plugin
export default {"main":"CheckboxVolunteerCell_main__zZ42U"};